export const NotificationChannel = {
  Email: 'email',
  SMS: 'sms',
  Push: 'push',
  WhatsApp: 'whatsapp',
  Telegram: 'telegram',
} as const

export type NotificationChannel =
  (typeof NotificationChannel)[keyof typeof NotificationChannel]

export interface EmailPayload {
  to: string
  subject: string
  body: string
  html?: string
  metadata?: Record<string, unknown>
}

export interface SMSPayload {
  to: string
  message: string
}

/** Twilio WhatsApp: numbers use `whatsapp:+E164` (from is optional override). */
export interface WhatsAppPayload {
  to: string
  message: string
  /** Optional override; defaults to `TWILIO_WHATSAPP_NUMBER` on the server. */
  from?: string
}

/** Telegram Bot API: numeric chat id or @username (not a phone number). */
export interface TelegramPayload {
  chatId: string
  message: string
  parseMode?: 'HTML' | 'Markdown' | 'MarkdownV2'
}

export interface PushPayload {
  title: string
  body: string
  icon?: string
  url?: string
  tag?: string
}

export interface NotificationResult {
  success: boolean
  channel: NotificationChannel
  messageId?: string
  error?: string
}

export interface NotificationRecord {
  id: string
  userAddress: string
  channel: NotificationChannel
  recipient: string
  subject?: string
  body: string
  status: 'sent' | 'failed'
  metadata?: Record<string, unknown>
  createdAt: string
}

export interface NotificationHistoryFilter {
  channel?: NotificationChannel
  status?: 'sent' | 'failed'
  limit?: number
  offset?: number
}

export interface PushSubscriptionData {
  endpoint: string
  keys: {
    p256dh: string
    auth: string
  }
}
